'use client';

import { useState } from 'react';
import MobileHeader from '../components/MobileHeader';

export default function Pricing() {
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'yearly'>('monthly');

  // Header HTML extraído del home
  const headerHTML = `<div class="w-full fixed top-0 p-3 flex justify-center items-center z-20 flex-col max-sm:hidden"><div class="w-full max-w-4xl flex justify-between items-center bg-[#f4f4f4] bg-opacity-40 rounded-full backdrop-blur-md px-2.5 py-2"><a aria-current="page" class="router-link-active router-link-exact-active flex gap-1 items-center" href="/"><div class="w-[36px] h-[36px]"><img src="/AbbiAI.png" alt="AbbiAI Logo" class="h-full w-full object-contain"/></div><div class="flex flex-col justify-center items-center"><h2 class="text-[18px] font-bold text-darkbrown dark:text-white"> AbbiAI</h2><span class="italic text-xs">IA con Propósito</span></div></a><nav class="hidden md:flex gap-5 items-center text-darkbrown"><a class="hover:underline" href="/">Inicio</a><a aria-current="page" class="router-link-active router-link-exact-active hover:underline" href="/pricing">Precios</a><a class="hover:underline" href="/contact">Contáctanos</a></nav><div class="flex gap-5 items-center text-darkbrown"><a class="" href="https://abbiai.it/login" target="_blank" rel="noopener noreferrer">Iniciar App</a></div></div></div>`;

  // Footer HTML extraído del home
  const footerHTML = `<div class="w-full flex flex-col bg-accentdarker border-t border-gray-300 py-7 gap-10 items-center"><div class="w-full max-w-5xl flex items-start justify-between px-8 max-md:flex-col max-md:gap-8"><div class="flex flex-col items-center gap-2.5"><div class="flex gap-1 items-center"><div class="w-[36px] h-[36px]"><img src="/AbbiAI.png" alt="AbbiAI Logo" class="h-full w-full object-contain"/></div><div class="flex flex-col justify-center items-start"><h2 class="text-[18px] font-bold text-darkbrown dark:text-white"> AbbiAI</h2><span class="italic text-xs">IA con Propósito</span></div></div><div class="flex items-center gap-3"><a onclick="return false;" style="cursor: pointer;"><div class="h-[32px]"><img alt="LinkedIn" class="h-full" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20width='800px'%20height='800px'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.72%203.99997H5.37C5.19793%203.99191%205.02595%204.01786%204.86392%204.07635C4.70189%204.13484%204.55299%204.22471%204.42573%204.34081C4.29848%204.45692%204.19537%204.59699%204.12232%204.75299C4.04927%204.909%204.0077%205.07788%204%205.24997V18.63C4.01008%2018.9901%204.15766%2019.3328%204.41243%2019.5875C4.6672%2019.8423%205.00984%2019.9899%205.37%2020H18.72C19.0701%2019.9844%2019.4002%2019.8322%2019.6395%2019.5761C19.8788%2019.32%2020.0082%2018.9804%2020%2018.63V5.24997C20.0029%205.08247%2019.9715%204.91616%2019.9078%204.76122C19.8441%204.60629%2019.7494%204.466%2019.6295%204.34895C19.5097%204.23191%2019.3672%204.14059%2019.2108%204.08058C19.0544%204.02057%2018.8874%203.99314%2018.72%203.99997ZM9%2017.34H6.67V10.21H9V17.34ZM7.89%209.12997C7.72741%209.13564%207.5654%209.10762%207.41416%209.04768C7.26291%208.98774%207.12569%208.89717%207.01113%208.78166C6.89656%208.66615%206.80711%208.5282%206.74841%208.37647C6.6897%208.22474%206.66301%208.06251%206.67%207.89997C6.66281%207.73567%206.69004%207.57169%206.74995%207.41854C6.80986%207.26538%206.90112%207.12644%207.01787%207.01063C7.13463%206.89481%207.2743%206.80468%207.42793%206.74602C7.58157%206.68735%207.74577%206.66145%207.91%206.66997C8.07259%206.66431%208.2346%206.69232%208.38584%206.75226C8.53709%206.8122%208.67431%206.90277%208.78887%207.01828C8.90344%207.13379%208.99289%207.27174%209.05159%207.42347C9.1103%207.5752%209.13699%207.73743%209.13%207.89997C9.13719%208.06427%209.10996%208.22825%209.05005%208.3814C8.99014%208.53456%208.89888%208.6735%208.78213%208.78931C8.66537%208.90513%208.5257%208.99526%208.37207%209.05392C8.21843%209.11259%208.05423%209.13849%207.89%209.12997ZM17.34%2017.34H15V13.44C15%2012.51%2014.67%2011.87%2013.84%2011.87C13.5822%2011.8722%2013.3313%2011.9541%2013.1219%2012.1045C12.9124%2012.2549%2012.7546%2012.4664%2012.67%2012.71C12.605%2012.8926%2012.5778%2013.0865%2012.59%2013.28V17.34H10.29V10.21H12.59V11.21C12.7945%2010.8343%2013.0988%2010.5225%2013.4694%2010.3089C13.84%2010.0954%2014.2624%209.98848%2014.69%209.99997C16.2%209.99997%2017.34%2011%2017.34%2013.13V17.34Z'%20fill='%23000000'/%3e%3c/svg%3e" width="25"/></div></a><a onclick="return false;" style="cursor: pointer;"><div class="h-[25px]"><img alt="Twitter" class="h-full" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20fill='%23000000'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='800px'%20height='800px'%20viewBox='0%200%20512%20512'%20xml:space='preserve'%3e%3cg%20id='7935ec95c421cee6d86eb22ecd12f847'%3e%3cpath%20style='display:%20inline;'%20d='M459.186,151.787c0.203,4.501,0.305,9.023,0.305,13.565%20c0,138.542-105.461,298.285-298.274,298.285c-59.209,0-114.322-17.357-160.716-47.104c8.212,0.973,16.546,1.47,25.012,1.47%20c49.121,0,94.318-16.759,130.209-44.884c-45.887-0.841-84.596-31.154-97.938-72.804c6.408,1.227,12.968,1.886,19.73,1.886%20c9.55,0,18.816-1.287,27.617-3.68c-47.955-9.633-84.1-52.001-84.1-102.795c0-0.446,0-0.882,0.011-1.318%20c14.133,7.847,30.294,12.562,47.488,13.109c-28.134-18.796-46.637-50.885-46.637-87.262c0-19.212,5.16-37.218,14.193-52.7%20c51.707,63.426,128.941,105.156,216.072,109.536c-1.784-7.675-2.718-15.674-2.718-23.896c0-57.891,46.941-104.832,104.832-104.832%20c30.173,0,57.404,12.734,76.525,33.102c23.887-4.694,46.313-13.423,66.569-25.438c-7.827,24.485-24.434,45.025-46.089,58.002%20c21.209-2.535,41.426-8.171,60.222-16.505C497.448,118.542,479.666,137.004,459.186,151.787z'%3e%3c/path%3e%3c/g%3e%3c/svg%3e" width="20"/></div></a><a onclick="return false;" style="cursor: pointer;"><div class="h-[30px]"><img alt="Youtube" class="h-full" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20fill='%23000000'%20width='800px'%20height='800px'%20viewBox='0%200%2032%2032'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%3e%3ctitle%3eyoutube%3c/title%3e%3cpath%20d='M12.932%2020.459v-8.917l7.839%204.459zM30.368%208.735c-0.354-1.301-1.354-2.307-2.625-2.663l-0.027-0.006c-3.193-0.406-6.886-0.638-10.634-0.638-0.381%200-0.761%200.002-1.14%200.007l0.058-0.001c-0.322-0.004-0.701-0.007-1.082-0.007-3.748%200-7.443%200.232-11.070%200.681l0.434-0.044c-1.297%200.363-2.297%201.368-2.644%202.643l-0.006%200.026c-0.4%202.109-0.628%204.536-0.628%207.016%200%200.088%200%200.176%200.001%200.263l-0-0.014c-0%200.074-0.001%200.162-0.001%200.25%200%202.48%200.229%204.906%200.666%207.259l-0.038-0.244c0.354%201.301%201.354%202.307%202.625%202.663l0.027%200.006c3.193%200.406%206.886%200.638%2010.634%200.638%200.38%200%200.76-0.002%201.14-0.007l-0.058%200.001c0.322%200.004%200.702%200.007%201.082%200.007%203.749%200%207.443-0.232%2011.070-0.681l-0.434%200.044c1.298-0.362%202.298-1.368%202.646-2.643l0.006-0.026c0.399-2.109%200.627-4.536%200.627-7.015%200-0.088-0-0.176-0.001-0.263l0%200.013c0-0.074%200.001-0.162%200.001-0.25%200-2.48-0.229-4.906-0.666-7.259l0.038%200.244z'%3e%3c/path%3e%3c/svg%3e" width="20"/></div></a><a onclick="return false;" style="cursor: pointer;"><div class="h-[30px]"><img alt="Discord" class="h-full" src="data:image/svg+xml,%3csvg%20width='30.67'%20xmlns='http://www.w3.org/2000/svg'%20height='23.249'%20viewBox='4019%20-1152%2030.67%2023.249'%20fill='none'%3e%3cpath%20d='M4045.001-1150.047a25.26%2025.26%200%200%200-6.339-1.953c-.279.48-.589%201.131-.806%201.643a24.228%2024.228%200%200%200-7.022%200%2020.164%2020.164%200%200%200-.806-1.643%2024.911%2024.911%200%200%200-6.341%201.953c-4.014%205.921-5.099%2011.702-4.557%2017.406%202.666%201.937%205.239%203.115%207.767%203.89a18.866%2018.866%200%200%200%201.658-2.681%2016.368%2016.368%200%200%201-2.619-1.256%209.64%209.64%200%200%200%20.635-.496c5.053%202.31%2010.526%202.31%2015.517%200%20.217.171.418.341.635.496-.837.496-1.705.914-2.619%201.256.48.945%201.038%201.844%201.658%202.681a25.708%2025.708%200%200%200%207.767-3.89c.666-6.603-1.056-12.338-4.528-17.406Zm-15.748%2013.887c-1.519%200-2.759-1.379-2.759-3.069%200-1.689%201.209-3.068%202.759-3.068%201.534%200%202.789%201.379%202.758%203.068%200%201.69-1.224%203.069-2.758%203.069Zm10.184%200c-1.519%200-2.76-1.379-2.76-3.069%200-1.689%201.21-3.068%202.76-3.068%201.535%200%202.79%201.379%202.759%203.068%200%201.69-1.209%203.069-2.759%203.069Z'%20style='fill:%20rgb(0,%200,%200);%20fill-opacity:%201;'%20class='fills'%20data-testid='svg-path'/%3e%3c/svg%3e" width="20"/></div></a></div></div><div class="flex flex-col gap-2.5"><div class="font-bold"><a href="https://info.mammouth.ai" rel="noopener noreferrer" target="_blank">Más Información</a></div><div class="flex flex-col gap-2"><a class="hover:underline" onclick="return false;" style="cursor: pointer;">Descarga la App en cualquier dispositivo</a><a class="hover:underline" onclick="return false;" style="cursor: pointer;">Herramientas Avanzadas con IA</a><a class="hover:underline" onclick="return false;" style="cursor: pointer;">Obtén siempre los mejores resultados</a></div></div><div class="flex flex-col gap-2.5"><div class="font-bold">Quiénes Somos</div><div class="flex flex-col gap-2"><a class="hover:underline" onclick="return false;" style="cursor: pointer;">Quiénes Somos</a><a class="hover:underline" onclick="return false;" style="cursor: pointer;">Política de Privacidad</a><a class="hover:underline" onclick="return false;" style="cursor: pointer;">Términos de Servicio</a></div></div></div><div class="flex flex-col gap-2 items-center text-center"><p>© 2025 AbbiAI. All rights reserved.</p></div></div>`;

  return (
    <>
      {/* Header */}
      <MobileHeader />
      
      {/* Contenido principal */}
      <div className="w-full flex flex-col gap-8 md:gap-16 items-center pt-24 md:pt-32 pb-24 mx-auto px-4">
        {/* Encabezado */}
        <div className="flex flex-col gap-6 items-center text-center w-full max-w-[1400px]">
          <h1 className="text-3xl md:text-5xl font-bold text-darkbrown">
            Precios
          </h1>
          <p className="text-lg md:text-xl text-text2 max-w-2xl">
            Obtén acceso a múltiples modelos de IA por el precio de uno.
          </p>
          
          {/* Selector de ciclo de facturación */}
          <div className="flex items-center gap-0 bg-white border border-gray-300 rounded-xl p-1">
            <button
              onClick={() => setBillingCycle('monthly')}
              className={`px-6 py-2 rounded-lg font-semibold text-sm md:text-base transition-all ${
                billingCycle === 'monthly'
                  ? 'bg-gray-200 text-darkbrown shadow-sm'
                  : 'bg-white text-gray-600 hover:text-darkbrown'
              }`}
            >
              Pagar Mensual
            </button>
            <button
              onClick={() => setBillingCycle('yearly')}
              className={`px-6 py-2 rounded-lg font-semibold text-sm md:text-base transition-all ${
                billingCycle === 'yearly'
                  ? 'bg-gray-200 text-darkbrown shadow-sm'
                  : 'bg-white text-gray-600 hover:text-darkbrown'
              }`}
            >
              Pagar Anual
            </button>
          </div>
        </div>

        {/* Tarjetas de Precios */}
        <div className="w-full max-w-[1400px] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {/* Plan Conecta */}
          <div className="bg-white border border-gray-300 rounded-xl p-6 flex flex-col gap-4 hover:border-gray-400 transition-all shadow-sm min-w-0">
            <div className="flex flex-col gap-2">
              <h3 className="text-2xl md:text-3xl font-bold text-darkbrown">"Conecta"</h3>
              <p className="text-lg md:text-xl font-bold text-darkbrown">USD {billingCycle === 'monthly' ? '10' : '100'}/{billingCycle === 'monthly' ? 'mes' : 'anual'}.</p>
              <a href="/contact" className="w-full text-white rounded-lg px-6 py-3 font-bold text-base transition-colors mt-2 shadow-md text-center block" style={{ backgroundColor: 'rgb(0, 80, 115)' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 100, 140)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 80, 115)'}>
                Contáctanos
              </a>
              <p className="text-sm text-text2 mt-2">Lo esencial para transformar tu productividad con IA.</p>
            </div>
            
            <div className="flex-1 flex flex-col gap-3">
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Acceso a los mejores Fabricantes de modelos del mundo. Utiliza LLMs poderosos y motores de razonamiento potentes.
              </div>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Generación de imágenes avanzada:
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Acceso a Nano Banana, GPT, Stable Diffusion, Recraft y FLUX.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Hasta 50 imágenes premium por mes.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Imágenes ilimitadas con Flux Schnell (modo de eficiencia visual).</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Análisis de documentos
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Carga y analiza documentos o textos de hasta 500,000 caracteres (~3 125 páginas).</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Resúmenes, interpretación de contenido, extracción de datos clave y recomendaciones automáticas.</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                El orquestador selecciona el modelo adecuado.
              </div>
            </div>
          </div>

          {/* Plan Avanzado */}
          <div className="bg-white border border-gray-300 rounded-xl p-6 flex flex-col gap-4 hover:border-gray-400 transition-all shadow-sm min-w-0">
            <div className="flex flex-col gap-2">
              <h3 className="text-2xl md:text-3xl font-bold text-darkbrown">"Avanzado"</h3>
              <p className="text-lg md:text-xl font-bold text-darkbrown">USD {billingCycle === 'monthly' ? '15' : '150'}/{billingCycle === 'monthly' ? 'mes' : 'anual'}.</p>
              <a href="/contact" className="w-full text-white rounded-lg px-6 py-3 font-bold text-base transition-colors mt-2 shadow-md text-center block" style={{ backgroundColor: 'rgb(0, 80, 115)' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 100, 140)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 80, 115)'}>
                Contáctanos
              </a>
              <p className="text-sm text-text2 mt-2">Lleva tu productividad al siguiente nivel con IA.</p>
            </div>
            
            <div className="flex-1 flex flex-col gap-3">
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Acceso a los mejores modelos del mundo. Utiliza los principales LLMs y motores de razonamiento:
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Claude, GPT, Llama, Grok, Mistral, Gemini y DeepSeek.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Modelos de razonamiento (Chain of Thought, CoT) para tareas complejas.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Modelos de investigación web y profunda, que amplían respuestas con fuentes actualizadas.</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Generación de imágenes avanzada:
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Acceso a Nano Banana, GPT, Stable Diffusion, Recraft y FLUX.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Hasta 120 imágenes premium por mes.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Imágenes ilimitadas con Flux Schnell (modo de eficiencia visual).</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Análisis de documentos
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Resúmenes, interpretación de contenido, extracción de datos clave y recomendaciones automáticas.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Carga y analiza documentos o textos de hasta 1,5 M caracteres (~375 páginas).</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                El usuario selecciona el modelo o herramienta.
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>El orquestador selecciona el modelo adecuado para optimizar recursos.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>El Usuario puede escoger modelos disponibles según su política de uso justo</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Políticas de Uso Justo, restricciones por 4 horas.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Plan Elite */}
          <div className="bg-white border border-gray-300 rounded-xl p-6 flex flex-col gap-4 hover:border-gray-400 transition-all shadow-sm min-w-0">
            <div className="flex flex-col gap-2">
              <h3 className="text-2xl md:text-3xl font-bold text-darkbrown">"Elite"</h3>
              <p className="text-lg md:text-xl font-bold text-darkbrown">USD {billingCycle === 'monthly' ? '20' : '200'}/{billingCycle === 'monthly' ? 'mes' : 'anual'}.</p>
              <a href="/contact" className="w-full text-white rounded-lg px-6 py-3 font-bold text-base transition-colors mt-2 shadow-md text-center block" style={{ backgroundColor: 'rgb(0, 80, 115)' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 100, 140)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 80, 115)'}>
                Contáctanos
              </a>
              <p className="text-sm text-text2 mt-2">Lo esencial para transformar tu productividad con IA.</p>
            </div>
            
            <div className="flex-1 flex flex-col gap-3">
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Acceso a los mejores modelos del mundo. Utiliza los principales LLMs y motores de razonamiento:
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Claude, GPT, Llama, Grok, Mistral, Gemini y DeepSeek.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Modelos de razonamiento (Chain of Thought, CoT) para tareas complejas.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Modelos de investigación web y profunda, que amplían respuestas con fuentes actualizadas.</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Generación de imágenes avanzada:
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Acceso a Nano Banana, GPT, Stable Diffusion, Recraft y FLUX.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Hasta 200 imágenes premium por mes.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Imágenes ilimitadas con Flux Schnell (modo de eficiencia visual).</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Análisis de documentos
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Resúmenes, interpretación de contenido, extracción de datos clave y recomendaciones automáticas.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Carga y analiza documentos o textos de hasta 4 M caracteres (~1000 páginas).</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                El usuario selecciona el modelo o herramienta.
              </div>
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>El orquestador selecciona el modelo adecuado para optimizar recursos.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>El Usuario puede escoger modelos disponibles según su política de uso justo</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Políticas de Uso Justo, restricciones por 2 horas.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Plan Empresa */}
          <div className="bg-white border-2 border-darkbrown rounded-xl p-6 flex flex-col gap-4 hover:border-darkbrown2 transition-all relative shadow-lg min-w-0">
            {/* Badge destacado */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-darkbrown text-white px-4 py-1 rounded-full text-xs font-bold">
              Recomendado
            </div>
            
            <div className="flex flex-col gap-2">
              <h3 className="text-2xl md:text-3xl font-bold text-darkbrown">"Empresa"</h3>
              <p className="text-lg md:text-xl font-bold text-darkbrown">USD {billingCycle === 'monthly' ? '25' : '250'}/{billingCycle === 'monthly' ? 'mes' : 'anual'}.</p>
              <a href="/contact" className="w-full text-white rounded-lg px-6 py-3 font-bold text-base transition-colors mt-2 shadow-md text-center block" style={{ backgroundColor: 'rgb(0, 80, 115)' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 100, 140)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgb(0, 80, 115)'}>
                Contáctanos
              </a>
              <p className="text-sm text-green-700 font-medium mt-2">Maximiza la productividad de tus colaboradores y permíteles dar el máximo de su potencial con IA.</p>
            </div>
            
            <div className="flex-1 flex flex-col gap-3">
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Lo mismo que Elite +
              </div>
              
              <ul className="flex flex-col gap-1.5 ml-4 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Hasta 300 imágenes premium por mes.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Carga y analiza documentos o textos de hasta 6 M caracteres (~1500 páginas).</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <span>Políticas de Uso Justo, restricciones por 1 hora.</span>
                </li>
              </ul>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Capacidad de compartir los proyectos con tu equipo de trabajo
              </div>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Almacenamiento de 50 Gigas
              </div>
              
              <div className="font-bold text-sm text-darkbrown flex items-center gap-2">
                <span className="text-darkbrown">▶</span>
                Portal empresarial.
              </div>
            </div>
          </div>
        </div>

        {/* Sección Funcionalidades Comunes */}
        <div className="w-full max-w-[1400px] mx-auto mt-8 p-6 bg-white border border-gray-300 rounded-xl">
          <div className="flex flex-col gap-6">
            <h3 className="text-2xl font-bold text-darkbrown">Funcionalidades comunes a todos los planes</h3>
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {/* Columna 1 (Izquierda): Frases cortas */}
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Datos cifrados de extremo a extremo</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Acceso desde portal web, móvil o PC</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Chat de voz y dictado</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Transcripción y respuesta natural</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Interacciones de texto ilimitadas</p>
                  </div>
                </div>
              </div>
              {/* Columna 2 (Derecha): Frases cortas + frases largas al final */}
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Interfaz unificada de texto, voz e imagen</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Habla con AbbiAI por voz o dicta tus ideas directamente</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Integración con WhatsApp (opcional)</p>
                  </div>
                </div>
                {/* Frases largas al final */}
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Motor de orquestación inteligente</p>
                    <p className="text-sm text-gray-700">Selecciona el modelo ideal basado en costo, velocidad y precisión.</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-lightbrown mt-1">✓</span>
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold text-darkbrown">Motor de orquestación inteligente</p>
                    <p className="text-sm text-gray-700">Selecciona el modelo más eficiente priorizando: Precisión, Costo y Velocidad.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div dangerouslySetInnerHTML={{ __html: footerHTML }} />
    </>
  );
}

